import { useMutation } from '@tanstack/react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { authApi } from '@/api/auth'
import { useAuthStore } from '@/store/authStore'
import { useDeviceStore } from '@/store/deviceStore'
import { queryClient } from '@/queryClient'

interface UseLogoutOptions {
  redirect?: boolean
  allowCurrentPathAfterLogout?: boolean
}

export function useLogout(options: UseLogoutOptions = {}) {
  const navigate = useNavigate()
  const location = useLocation()
  const authLogout = useAuthStore((s) => s.logout)
  const clearDevice = useDeviceStore((s) => s.clear)
  const { redirect = true, allowCurrentPathAfterLogout = false } = options

  return useMutation({
    mutationFn: async () => {
      try {
        const res = await authApi.logout()
        return res.data.data
      } catch {
        // network/server failure는 무시 — 클라이언트 측 클리어는 계속 진행
        return { success: true as const, attendanceUpdated: false }
      }
    },
    onSettled: () => {
      authLogout({
        postLogoutAllowedPath: allowCurrentPathAfterLogout ? location.pathname : null,
      })
      clearDevice()
      queryClient.clear()
      if (redirect) {
        navigate('/login', { replace: true })
      }
    },
  })
}
